import { render, staticRenderFns } from "./onlyFooter.vue?vue&type=template&id=ba9ab6da&scoped=true&"
import script from "./onlyFooter.vue?vue&type=script&lang=js&"
export * from "./onlyFooter.vue?vue&type=script&lang=js&"
import style0 from "./onlyFooter.vue?vue&type=style&index=0&id=ba9ab6da&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba9ab6da",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Bottom: require('/app/components/bottom.vue').default})
